import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import Button from 'modules/common/components/Button';
import { Spinner } from 'modules/common/components';
// import {
//   SummaryItem,
//   SummaryTitle,
//   SummaryCount,
//   LoaderWrapper,
//   SummaryIcon
// } from '../styles';
import { colors } from 'modules/common/styles';
import {
  InsightTitle,
  LoaderWrapper,
  StatusCount,
  StatusItem,
  StatusTitle,
  SummaryCount,
  SummaryIcon,
  SummaryItem,
  SummaryTitle
} from '../styles/main';
const propTypes = {
  data: PropTypes.array.isRequired,
  loading: PropTypes.bool
};

class AdminDashboardTileTheme extends React.Component {
  renderStatus(status) {
    return (
      <Col
        sm={3}
        key={Math.random()}
        style={{padding: '5px 0px'}}
      >
        <StatusItem>
          {/* <img src="/images/MissedCall.png" /> */}
          
          {status.icon}
          {/* {status.icon} */}
          <StatusCount>{status.count} </StatusCount>
          <StatusTitle>{status.title}</StatusTitle>
          {/* <div className="progress">
            <div className="progress-bar" role="progressbar"></div>
          </div> */}
        </StatusItem>
      </Col>
    );
  }

  renderTitle(title) {
    const { __ } = this.context;
    return (
      <InsightTitle style={{padding: '0px', marginTop: '0px', fontWeight: '500', textTransform: 'none'}}>
        {__(title)}
      </InsightTitle>
    );
  }

  render() {
    const { __ } = this.context;
    const { data, loading } = this.props;

    if (loading) {
      return (
        <LoaderWrapper>
          <Spinner objective />
        </LoaderWrapper>
      );
    }

    return (
      <Row
        style={{
          padding: '20px',
          background: colors.colorWhite,
          borderRadius: '20px'
        }}
      >
        {this.renderTitle('RCS Delivery Status')}
        {data && data.map(detail => this.renderStatus(detail))}
      </Row>
    );
  }
}

AdminDashboardTileTheme.contextTypes = {
  __: PropTypes.func
};

AdminDashboardTileTheme.propTypes = propTypes;

export default AdminDashboardTileTheme;



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/AdminDashboardTileTheme.js